export default __webpack_public_path__ + "static/media/step-five.4105a998.png";